import { StackIcon } from "@xola/icons";
import clsx from "clsx";
import React from "react";
import { Currency } from "../../../Common/Currency";
import { PurchaseBalanceBadge } from "../../Common/PurchaseBalanceBadge";
import { RowData } from "./types";

export const amountDueCellValueGetter = ({ data }: { data: RowData }) => {
    if ("balance" in data) {
        return data.balance;
    }

    return data.item.purchase.balance;
};

export const AmountDueCellRenderer = ({ data }: { data: RowData }) => {
    if ("balance" in data && data.balance > 0) {
        return (
            <span className="no-translate">
                <StackIcon size="small" className="mr-1" />
                <Currency>{data.balance}</Currency>
            </span>
        );
    }

    if ("isOrganizer" in data && data.item.purchase.balance > 0) {
        return (
            <span className="no-translate mt-1 flex h-full items-start">
                <PurchaseBalanceBadge
                    purchase={data.item.purchase}
                    item={data.item}
                    size="medium"
                    className={clsx("!rounded !text-sm font-bold tracking-normal")}
                />
            </span>
        );
    }

    return null;
};
